export default "__VITE_ASSET__B19fHc6K__"